import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import localization from '../../localization';

import '../StripedDetailSection/stripedDetailSection.scss';

const ScrollSectionLayout = ({
  label,
  children,
  wrapperWidth = '100%',
  contentWidth = '100%',
  wrapperStyle,
  dataTest = '',
  sectionRef,
  setSelectedSection,
  selectedSection,
  withTitle,
}) => (
  <Box
    className="std"
    data-test={dataTest}
    mb={3}
    bgcolor="#fff"
    width={wrapperWidth}
    pb={4}
    sx={wrapperStyle}
    position="relative"
    id={sectionRef?.section}
    ref={sectionRef?.ref}
    onMouseEnter={() => {
      if (selectedSection !== sectionRef?.section) { setSelectedSection(sectionRef?.section); }
    }}
  >
    {withTitle && (
      <Box p={4} className="std__title std__title--main">
        <Typography gutterBottom variant="h4">
          {localization.t(`labels.${sectionRef?.section || label}`)}
        </Typography>
      </Box>
    )}
    <Box display="flex" flexDirection="column" width={contentWidth} px={2} height="100%">
      {children}
    </Box>
  </Box>
);

ScrollSectionLayout.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  wrapperWidth: PropTypes.string,
  contentWidth: PropTypes.string,
  dataTest: PropTypes.string,
  sectionRef: PropTypes.object,
  setSelectedSection: PropTypes.func,
  selectedSection: PropTypes.string,
  withTitle: PropTypes.bool,
  wrapperStyles: PropTypes.object,
};

ScrollSectionLayout.defaultProps = {
  withTitle: true,
};

export default ScrollSectionLayout;
